let BASE_URL = 'https://api-us.zapiet.com/v1.0/';
let shop = Shopify.shop;
let checkoutBtns = document.getElementsByName('checkout');
let locationZipcode = sessionStorage.getItem('location_zip') || "";
let deliveryTypeHandle = sessionStorage.getItem('delivery_type_handle') || "";

let checkoutMethod = '';
let defualtPage = 1;
let defualtSpinner = 1;
let zapietLocationId = sessionStorage.getItem("zapiet_location_id") || "";
let orderValue = sessionStorage.getItem('order_value') || 0;
let orderCondition = sessionStorage.getItem('order_condition') || "";

if (shopifyCartItems.length > 0) {
	setTimeout(function () {
		if (document.getElementById('storePickupAppCustom')) {
			let storePickupAppCustom = document.getElementById('storePickupAppCustom');
			if (deliveryTypeHandle !== '') {
				initSelectedMethod(deliveryTypeHandle, defualtPage, true);

				if (deliveryTypeHandle == 'nation') {
					checkoutMethod = 'shipping';
				} else if (deliveryTypeHandle == 'delivery' || deliveryTypeHandle == 'market' || deliveryTypeHandle == 'local') {
					checkoutMethod = 'delivery';

					if (document.querySelectorAll('.custom-cart-note')?.length > 0 && sessionStorage.getItem('delivery_type') === 'SUPERMARKET DELIVERY') {
						document.querySelectorAll('.custom-cart-note').forEach(function (e) {
							e.style.display = 'block';
						});
					}
				} else if (deliveryTypeHandle == 'standard-pickup' || deliveryTypeHandle == "market-pickup") {
					checkoutMethod = 'pickup';

					if (document.getElementById('cart_shipping__title')) {
						document.getElementById('cart_shipping__title').innerText = 'Pickup & Taxes';
					}
				}
			}
		}
	}, 1000);
}
const xhrCURLRequest = (method, url, data = {}) => {
	const xhr = new XMLHttpRequest();
	return new Promise(resolve => {
		xhr.open(method, url, true);
		xhr.onload = () => resolve({
			status: xhr.status,
			response: xhr.responseText
		});
		xhr.onerror = () => resolve({
			status: xhr.status,
			response: xhr.responseText
		});
		if (method != 'GET') xhr.setRequestHeader('Content-Type', 'application/json');
		data != {} ? xhr.send(JSON.stringify(data)) : xhr.send();
	});
};
const getUrlParameterCustom = function(baseURL, sParam) {
	const queryString = baseURL;
	const urlParams = new URL(queryString);
	return urlParams.searchParams.get(sParam) === undefined ? true : decodeURIComponent(urlParams.searchParams.get(sParam));
};
const initSelectedMethod = async function initSelectedMethod(type, selectedPage, isPagination, geoSearchQuery = '', localTimeSlot = []) {
	var innerCartHolder = [];
	if (shopifyCartItems.length > 0) {
		(shopifyCartItems).forEach(function (item) {
			var tempItem = {};
			tempItem['variant_id'] = item.variant_id;
			tempItem['product_id'] = item.product_id;
			tempItem['quantity'] = item.quantity;
			innerCartHolder.push(tempItem);
		});
	};

	var typeValidate = '';
	if (type == 'nation') {
		typeValidate = 'shipping';
	} else if (type == 'delivery' || type == 'market' || type == 'local') {
		typeValidate = 'delivery';
	} else if (type == 'standard-pickup' || type == "market-pickup") {
		typeValidate = 'pickup';
	}

	if (defualtSpinner === 1) {
		document.getElementById("popup_loader").style.display = "block";
	} else {
		document.getElementById('proccessSpinner').innerHTML = '';
		document.getElementById('proccessSpinner').innerHTML = '<div class=spinnerContainer> <i class="fa fa-spinner fa-spin"></i> </div>';
	}
	// checkoutBtns.forEach(element => { element.disabled = true });

	var data = {};
	data['deliveryTypeHandle'] = type;

	switch (type) {
		case 'nation':
			isShippingOrderValue = true;
			data['shippingMinimumOrderText'] = '';

			if (parseFloat(orderValue) > 0) {
				if (orderCondition === 'GREATER_THAN' && cartTotal <= parseFloat(orderValue)) {
					isShippingOrderValue = false;
					data['shippingMinimumOrderText'] = 'Minimum';
				} else if (orderCondition === 'LESS_THAN' && cartTotal >= parseFloat(orderValue)) {
					isShippingOrderValue = false;
					data['shippingMinimumOrderText'] = 'Maximum';
				}
			}

			if (isShippingOrderValue == true) {
				var params = {};
				params['shop'] = shop;

				/*let localShippingResponse = await xhrCURLRequest('POST', BASE_URL+'shipping/calendar', params);
				if(localShippingResponse.status==200){
				  var resultShipping = JSON.parse(localShippingResponse.response);
				  var minDate = (resultShipping.minDate!==null) ? convertDateFormat(resultShipping.minDate):'';
				  var maxDate = (resultShipping.maxDate!==null) ? convertDateFormat(resultShipping.maxDate):'';
				  setTimeout(function(){ initializationDatePicker(minDate, maxDate, '', resultShipping.disabled); },1000);
				}*/
				data['isError'] = false;
				data['isShippingMinimumOrderValue'] = false;
			} else {
				data['isError'] = false;
				data['isShippingMinimumOrderValue'] = true;
			}
			data['shippingMinimumOrderValue'] = parseFloat(orderValue).toFixed(2);
			data['deliveryType'] = sessionStorage.getItem('delivery_type') || "Shipping";
			break;
		case 'delivery':
		case 'market':
		case 'local':
			let validationDeliveryResponse = await xhrCURLRequest('POST', BASE_URL + typeValidate + '/validate', { 'shop': shop, shoppingCart: innerCartHolder });
			if (validationDeliveryResponse.status === 200) {
				var validationDeliveryResult = JSON.parse(validationDeliveryResponse.response);
				if (validationDeliveryResult.productsEligible === true) {
					isLocalDeliveryOrderValue = true;
					data['localDeliveryMinimumOrderText'] = '';

					if (parseFloat(orderValue) > 0) {
						if (orderCondition === 'GREATER_THAN' && cartTotal <= parseFloat(orderValue)) {
							isLocalDeliveryOrderValue = false;
							data['localDeliveryMinimumOrderText'] = 'Minimum';
						} else if (orderCondition === 'LESS_THAN' && cartTotal >= parseFloat(orderValue)) {
							isLocalDeliveryOrderValue = false;
							data['localDeliveryMinimumOrderText'] = 'Maximum';
						}
					}

					if (isLocalDeliveryOrderValue == true) {
						var params = {};
						params['shop'] = shop;

						var geoSearchQuery = sessionStorage.getItem('location_zip') || "";
						if (geoSearchQuery !== "") {
							params['geoSearchQuery'] = geoSearchQuery;
							if (innerCartHolder.length > 0) { params['shoppingCart'] = innerCartHolder; }
							/*let localLocationResponse = await xhrCURLRequest('POST', BASE_URL+'delivery/locations', params);
							if(localLocationResponse.status==200){
							  var result = JSON.parse(localLocationResponse.response);
							  if(!result.error){*/
							const locationId = zapietLocationId;
							let localCalendarResponse = await xhrCURLRequest('POST', BASE_URL + 'delivery/locations/' + zapietLocationId + '/calendar', params);
							if (localCalendarResponse.status == 200) {
								var resultCalendar = JSON.parse(localCalendarResponse.response);
								// var minDate = (resultCalendar.minDate!==null) ? convertDateFormat(resultCalendar.minDate):'';
								// var maxDate = (resultCalendar.maxDate!==null) ? convertDateFormat(resultCalendar.maxDate):'';
								var minDate = (resultCalendar.minDate !== null) ? moment.tz(resultCalendar.minDate, resultCalendar.timezone).format("MM/DD/YYYY") : '';
								var maxDate = (resultCalendar.maxDate !== null) ? moment.tz(resultCalendar.maxDate, resultCalendar.timezone).format("MM/DD/YYYY") : '';

								let selectedDeliveryType = sessionStorage.getItem('delivery_type') || "";
								if (selectedDeliveryType != '' && selectedDeliveryType == "GRAB-AND-GO DELIVERY") {
									minDate = convertDateFormat(getNextDayDate());
								}

								setTimeout(function () { initializationDatePicker(minDate, maxDate, locationId, resultCalendar.disabled); }, 1000);
							}
							data['isError'] = false;
							/*}else{
							  data['isError'] = true;
							}
						  }*/
						} else { data['isError'] = false; }

						data['location_time_slot'] = localTimeSlot;
						data['delivery_location'] = {};
						data['deliveryType'] = sessionStorage.getItem('delivery_type') || "Delivery";
						data['locationZipcode'] = geoSearchQuery;
						data['isLocalDeliveryMinimumOrderValue'] = false;
					} else {
						data['deliveryType'] = sessionStorage.getItem('delivery_type') || "Delivery";
						data['isLocalDeliveryMinimumOrderValue'] = true;
						data['isError'] = false;
					}
					data['localDeliveryMinimumOrderValue'] = parseFloat(orderValue).toFixed(2);
				} else {
					checkoutBtns.forEach(element => { element.disabled = false });
				}
			}
			break;
		case 'standard-pickup':
		case 'market-pickup':
			let validationPickupResponse = await xhrCURLRequest('POST', BASE_URL + typeValidate + '/validate', { 'shop': shop, shoppingCart: innerCartHolder });
			if (validationPickupResponse.status === 200) {
				var validationPickupResult = JSON.parse(validationPickupResponse.response);
				if (validationPickupResult.productsEligible === true) {
					isStorePickupOrderValue = true;
					data['storePickupMinimumOrderText'] = '';

					if (parseFloat(orderValue) > 0) {
						if (orderCondition === 'GREATER_THAN' && cartTotal <= parseFloat(orderValue)) {
							isStorePickupOrderValue = false;
							data['storePickupMinimumOrderText'] = 'Minimum';
						} else if (orderCondition === 'LESS_THAN' && cartTotal >= parseFloat(orderValue)) {
							isStorePickupOrderValue = false;
							data['storePickupMinimumOrderText'] = 'Maximum';
						}
					}

					if (isStorePickupOrderValue == true) {
						var params = {};
						params['shop'] = shop;
						params['page'] = selectedPage;
						if (innerCartHolder.length > 0) { params['shoppingCart'] = innerCartHolder; }

						if (locationZipcode !== "") { params['geoSearchQuery'] = sessionStorage.getItem('location_zip') || ""; }
						let locationResponse = await xhrCURLRequest('POST', BASE_URL + 'pickup/locations', params);

						var locationsArray = [];
						var selectedLocationsArray = '';
						if (locationResponse.status == 200) {
							var result = JSON.parse(locationResponse.response);
							var locationTitle = sessionStorage.getItem('location_title') || '';
							locationsArray = (result.locations.length > 0) ? result.locations : [];
							var pagination = (typeof result.pagination !== 'undefined') ? result.pagination : [];
							if (locationsArray.length > 0) {
								data['locationTitle'] = locationTitle;
								data['prevPageURL'] = (pagination.prev_page_url === null) ? "" : getUrlParameterCustom(pagination.prev_page_url, 'page');
								data['nextPageURL'] = (pagination.next_page_url === null) ? "" : getUrlParameterCustom(pagination.next_page_url, 'page');
								var current_page = (pagination.current_page === null) ? "1" : pagination.current_page;
								sessionStorage.setItem('current_page', current_page);

								var isEnabledDatePicker = false;
								/*const isLocationExist = locationsArray.filter(function (item) { return item.company_name == locationTitle; });*/
                                const isLocationExist = locationsArray.filter(function (item) { return item.id == zapietLocationId; });
								if (isLocationExist.length > 0) {
									let locationCalendarResponse = await xhrCURLRequest('POST', BASE_URL + 'pickup/locations/' + isLocationExist[0].id + '/calendar', params);
									if (locationCalendarResponse.status == 200) {
										var resultLocationCalendar = JSON.parse(locationCalendarResponse.response);
										var minDate = (resultLocationCalendar.minDate !== null) ? moment.tz(resultLocationCalendar.minDate, resultLocationCalendar.timezone).format("MM/DD/YYYY") : '';
										var maxDate = (resultLocationCalendar.maxDate !== null) ? moment.tz(resultLocationCalendar.maxDate, resultLocationCalendar.timezone).format("MM/DD/YYYY") : '';
										setTimeout(function () { initializationDatePicker(minDate, maxDate, isLocationExist[0].id, resultLocationCalendar.disabled, resultLocationCalendar); }, 1000);
										isEnabledDatePicker = true;
									}
									selectedLocationsArray = isLocationExist[0];
								}

								var nextPage = (pagination.next_page_url === null) ? "" : getUrlParameterCustom(pagination.next_page_url, 'page');
								if (isLocationExist.length == 0 && nextPage && isPagination == true) {
									initSelectedMethod(type, nextPage, true);
								}
							}
						}
						data['isEnabledDatePicker'] = isEnabledDatePicker;
						data['locations'] = locationsArray;
						data['selected_location'] = selectedLocationsArray;
						data['isStorePickupMinimumOrderValue'] = false;
					} else {
						data['isStorePickupMinimumOrderValue'] = true;
					}
					data['storePickupMinimumOrderValue'] = parseFloat(orderValue).toFixed(2);
				} else {
					checkoutBtns.forEach(element => { element.disabled = false });
				}
			}
			break;
	}
	if (data.deliveryTypeHandle.length > 0) {
		var bindHTML = await tmpl("store_pickup_tmpl", data);
		storePickupAppCustom.innerHTML = bindHTML;
		document.getElementById('proccessSpinner').innerHTML = '';
	}

	if (defualtSpinner === 1) {
		document.getElementById("popup_loader").style.display = "";
		defualtSpinner = 0;
	}
};
const setLocation = function setLocation(e) {
	document.getElementById('proccessSpinner').innerHTML = '';
	document.getElementById('proccessSpinner').innerHTML = '<div class=spinnerContainer> <i class="fa fa-spinner fa-spin"></i> </div>';
	var locationElement = document.getElementsByClassName('location');
	for (var i = 0; i <= locationElement.length; i++) {
		if (locationElement[i]) {
			locationElement[i].classList.remove('active');
		}
	}

	if (document.getElementById('location_' + e)) {
		var locsElement = document.getElementById('location_' + e);
		locsElement.classList.add('active');
		locsElement.querySelector("input[type=radio]").checked = true;

		if (document.getElementById('location_id_' + e)) {
			let current_page = sessionStorage.getItem('current_page') || "";
			var getLocationData = JSON.parse(document.getElementById('location_id_' + e).innerText);

			var company_name = (getLocationData.company_name !== null) ? getLocationData.company_name : '';
			var address_line_1 = (getLocationData.address_line_1 !== null) ? getLocationData.address_line_1 : '';
			var city = (getLocationData.city !== null) ? getLocationData.city : '';
			var region = (getLocationData.region !== null) ? getLocationData.region : '';
			var postal_code = (getLocationData.postal_code !== null) ? getLocationData.postal_code : '';
			var fullAddress = address_line_1 + ', ' + city + ', ' + region + ' ' + postal_code;

			sessionStorage.setItem('location_title', company_name);
			sessionStorage.setItem('location_address', fullAddress);

			initSelectedMethod(deliveryTypeHandle, current_page, true);
		}
	}
};
const getInformationLink = function getInformationLink(e) {
	var element = document.getElementById(e).outerHTML;
	var html = '';
	html += '<div class="mfp-bg zapiet-modal mfp-ready"></div><div class="mfp-wrap mfp-close-btn-in mfp-auto-cursor zapiet-modal mfp-ready" tabindex="-1" style="overflow: hidden auto;"><div class="mfp-container mfp-s-ready mfp-inline-holder"><div class="mfp-content">' + element.replace('mfp-hide ', '') + '</div><div class="mfp-preloader">Loading...</div></div></div>';
	document.getElementsByTagName('body')[0].insertAdjacentHTML("afterbegin", html);
	document.documentElement.style.overflow = 'hidden';
	document.documentElement.style.marginRight = '17px';
};
const closeModalFormPopup = function closeModalFormPopup() {
	document.documentElement.style.overflow = '';
	document.documentElement.style.marginRight = '';
	document.querySelector('.mfp-wrap.mfp-close-btn-in.mfp-auto-cursor.zapiet-modal.mfp-ready').remove();
	document.querySelector('.mfp-bg.zapiet-modal.mfp-ready').remove();
};
const previousFn = function previousFn(page) {
	if (page) { initSelectedMethod(deliveryTypeHandle, page, false); }
};
const nextFn = function nextFn(page) {
	if (page) { initSelectedMethod(deliveryTypeHandle, page, false); }
};
const convertFrom24To12Format = (time24) => {
	const [sHours, minutes] = time24.match(/([0-9]{1,2}):([0-9]{2})/).slice(1);
	const period = +sHours < 12 ? 'AM' : 'PM';
	const hours = +sHours % 12 || 12;

	return `${hours}:${minutes} ${period}`;
};
const getDeliveryLocations = function getDeliveryLocations(e) {
	var geoSearchQuery = document.getElementById('deliveryGeoSearchField').value;
	sessionStorage.setItem('location_zip', geoSearchQuery);
	initSelectedMethod(deliveryTypeHandle, 1, false, geoSearchQuery);
};
const convertDateFormat = (date) => {
	var today = new Date(date);
	var dd = String(today.getDate()).padStart(2, '0');
	var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
	var yyyy = today.getFullYear();

	today = mm + '/' + dd + '/' + yyyy;

	return today;
};
const getCurrentDateOnly = () => {
	var today = new Date();
	var dd = String(today.getDate()).padStart(2, '0');
	var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
	var yyyy = today.getFullYear();

	today = yyyy + '-' + mm + '-' + dd;

	return today;
}
const fetchLocationDateWiseTimeSlot = async (locationId, selectedDate) => {
	checkoutBtns.forEach(element => { element.disabled = true });
	document.getElementById('proccessSpinner').innerHTML = '';
	document.getElementById('proccessSpinner').innerHTML = '<div class=spinnerContainer> <i class="fa fa-spinner fa-spin"></i> </div>';
	var deliveryCalendarTimeSlot = document.getElementById('deliveryCalendarTimeSlot');
	var selectedDateToDay = moment(selectedDate).format("dddd").toLowerCase();


	deliveryCalendarTimeSlot.innerHTML = '';
	var innerTimeHolderHTML = '';
	let localCalendarTimeResponse = await xhrCURLRequest('POST', BASE_URL + 'delivery/locations/' + locationId + '/calendar/' + selectedDate, { 'shop': shop });
	if (localCalendarTimeResponse.status == 200) {
		var resultCalendarTime = JSON.parse(localCalendarTimeResponse.response);
		if (resultCalendarTime.length > 0) {
			innerTimeHolderHTML += '<div class="info-group">';
			innerTimeHolderHTML += '<div class="info-group-left symbol-group">';
			innerTimeHolderHTML += '<div class="info-icon-container">';
			innerTimeHolderHTML += '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 100 100" style="enable-background:new 0 0 100 100;" xml:space="preserve">';
			innerTimeHolderHTML += '<g>';
			innerTimeHolderHTML += '<path d="M90.65,45.87c0,1.56,0,3.13,0,4.69c-0.17,1.34-0.29,2.68-0.51,4.01c-1.39,8.3-4.93,15.56-10.87,21.52   c-9.68,9.7-21.42,13.59-34.97,11.61c-8.38-1.23-15.65-4.96-21.64-10.95C13.66,67.77,9.7,56.85,10.85,44.21   c0.77-8.49,4.1-15.98,9.75-22.37c6.2-7.01,13.92-11.38,23.14-13.02c1.51-0.27,3.03-0.42,4.55-0.62c1.56,0,3.13,0,4.69,0   c0.56,0.06,1.13,0.13,1.69,0.19c8.58,0.96,16.16,4.23,22.59,10c6.87,6.17,11.16,13.82,12.77,22.93   C90.3,42.83,90.45,44.35,90.65,45.87z M50.63,82.48C69.52,82.49,84.84,67.2,84.9,48.26c0.07-18.88-15.32-34.3-34.25-34.31   c-18.89-0.01-34.21,15.28-34.28,34.21C16.31,67.04,31.7,82.46,50.63,82.48z"/>';
			innerTimeHolderHTML += '<path d="M52.4,47.56c0.44,0,0.75,0,1.06,0c5.81,0,11.61,0,17.42,0c1.68,0,2.74,0.75,3.1,2.17c0.43,1.66-0.73,3.32-2.44,3.5   c-0.28,0.03-0.57,0.04-0.86,0.04c-6.88,0-13.75,0-20.63,0.01c-1,0-2-0.09-2.6-0.95c-0.39-0.56-0.74-1.31-0.74-1.98   c-0.05-7.76-0.05-15.52-0.02-23.28c0-1.74,1.25-2.95,2.89-2.93c1.62,0.02,2.8,1.24,2.81,3.01c0.02,6.46,0.01,12.92,0.01,19.38   C52.4,46.83,52.4,47.13,52.4,47.56z"/>';
			innerTimeHolderHTML += '</g>';
			innerTimeHolderHTML += '</svg>';
			innerTimeHolderHTML += '</div>';
			innerTimeHolderHTML += '</div>';
			innerTimeHolderHTML += '<div class="info-group-center label-group">';
			innerTimeHolderHTML += '<div class="info-group-row"></div>';
			innerTimeHolderHTML += '</div>';
			innerTimeHolderHTML += '<div class="info-group-right select-group">';
			innerTimeHolderHTML += '<div class="info-group-row" data-test-id="time-select">';
			innerTimeHolderHTML += '<div id="ember1421" class="pickup-time-select selected ember-view standard-dropdown sg-form-field valid">';
			innerTimeHolderHTML += '<label class="form-field--label" for="ember1421-select">Delivery Time</label>';
			innerTimeHolderHTML += '<div class="select-field-wrap">';
			innerTimeHolderHTML += '<select onChange="setDeliveryTimeSlot();" id="deliveryTimeSlot" class="selected">';
			innerTimeHolderHTML += '<option value="" class="ember-view">Select time slot</option>';
			let isAvailableTimeSolt = false;
			resultCalendarTime.forEach(function (item) {
				if (selectedDate !== getCurrentDateOnly()) {
					isAvailableTimeSolt = true;
					innerTimeHolderHTML += '<option data-locationid="' + item.location_id + '" data-start-time="' + item.available_from + '" data-slotid="' + item.id + '" value="' + convertFrom24To12Format(item.available_from) + ' - ' + convertFrom24To12Format(item.available_until) + '">' + capitalizeFirstLetter(selectedDateToDay) + ', ' + convertFrom24To12Format(item.available_from) + ' to ' + convertFrom24To12Format(item.available_until) + '</option>';
				} else {
					if ((item.available_from >= moment().tz("America/New_York").add(30, 'minutes').format('HH:MM')) == true) {
						isAvailableTimeSolt = true;
						innerTimeHolderHTML += '<option data-locationid="' + item.location_id + '" data-start-time="' + item.available_from + '" data-slotid="' + item.id + '" value="' + convertFrom24To12Format(item.available_from) + ' - ' + convertFrom24To12Format(item.available_until) + '">' + capitalizeFirstLetter(selectedDateToDay) + ', ' + convertFrom24To12Format(item.available_from) + ' to ' + convertFrom24To12Format(item.available_until) + '</option>';
					}
				}
			});
			innerTimeHolderHTML += '</select>';
			innerTimeHolderHTML += '</div>';
			innerTimeHolderHTML += '</div>';
			innerTimeHolderHTML += '</div>';
			innerTimeHolderHTML += '</div>';
			innerTimeHolderHTML += '</div>';

			if (isAvailableTimeSolt === true) {
				deliveryCalendarTimeSlot.innerHTML = innerTimeHolderHTML;
			} else {
				deliveryCalendarTimeSlot.innerHTML = '<p class="error">Sorry, no time slot available for the selected date.</p>';
			}
		} else {
			deliveryCalendarTimeSlot.innerHTML = '<p class="error">Sorry, no time slot available for the selected date.</p>';
		}
	}
	document.getElementById('proccessSpinner').innerHTML = '';
};
const setDeliveryTimeSlot = function setDeliveryTimeSlot(e) {
	document.getElementById('proccessSpinner').innerHTML = '';
	document.getElementById('proccessSpinner').innerHTML = '<div class=spinnerContainer> <i class="fa fa-spinner fa-spin"></i> </div>';
	var e = document.getElementById("deliveryTimeSlot");
	var value = e.options[e.selectedIndex].value;
	var locationId = e.options[e.selectedIndex].getAttribute('data-locationid');
	var slotId = e.options[e.selectedIndex].getAttribute('data-slotid');
	var startTime = e.options[e.selectedIndex].getAttribute('data-start-time');
	var selectedDate = document.querySelector("input[name=datetime]");

	var checkoutMethodElement = document.querySelector("input[name='attributes[Checkout-Method]']");
	var deliveryLocationIdElement = document.querySelector("input[name='attributes[Delivery-Location-Id]']");
	var deliveryDateElement = document.querySelector("input[name='attributes[Delivery-Date]']");
	var deliverySlotIdElement = document.querySelector("input[name='attributes[Delivery-Slot-Id]']");
	var deliveryTimeElement = document.querySelector("input[name='attributes[Delivery-Time]']");

	if (value.length > 0 && typeof locationId !== 'undefined' && slotId !== 'undefined' && selectedDate.value !== 'undefined') {
		var setedDate = moment(selectedDate.value).format("YYYY/MM/DD");
		var getDeliveryLocationData = JSON.parse(document.getElementById('delivery_location_id_' + locationId).innerText);

		/*var deliveryRegion = (getDeliveryLocationData.region!==null)?getDeliveryLocationData.region:'';
		var deliveryCountry = (getDeliveryLocationData.country!==null)?getDeliveryLocationData.country:'';*/
		var localDeliveryZipCode = sessionStorage.getItem('location_zip') || "";

		if (localDeliveryZipCode != '') {
			if (document.getElementsByTagName('form')) {
				var formElement = document.getElementsByTagName('form');
				if (formElement.length > 0) {
					for (let i = 0; i < formElement.length; i++) {
						if (formElement[i].action.includes('/cart')) {
							formElement[i].action = "/cart?step=contact_information&method=" + checkoutMethod + "&skip_shopify_pay=true&shipping_address_zip=" + localDeliveryZipCode + "&discount=+&locale=" + Shopify.locale;
						}
					}
				}
			}
		}

		checkoutMethodElement.value = checkoutMethod;
		deliveryLocationIdElement.value = locationId;
		deliveryDateElement.value = setedDate;
		deliverySlotIdElement.value = slotId;
		deliveryTimeElement.value = value;

		updateCartAttributes();
		addZapietId(setedDate, locationId, startTime, checkoutMethod);

		checkoutBtns.forEach(element => { element.disabled = false });
	} else {
		checkoutMethodElement.value = '';
		deliveryLocationIdElement.value = '';
		deliveryDateElement.value = '';
		deliverySlotIdElement.value = '';
		deliveryTimeElement.value = '';

		updateCartAttributes();
		checkoutBtns.forEach(element => { element.disabled = true });
	}
	document.getElementById('proccessSpinner').innerHTML = '';
};
const setShippingDate = function setShippingDate() {
	setTimeout(function () {
		checkoutBtns.forEach(element => { element.disabled = true });
		document.getElementById('proccessSpinner').innerHTML = '';
		document.getElementById('proccessSpinner').innerHTML = '<div class=spinnerContainer> <i class="fa fa-spinner fa-spin"></i> </div>';
		//var selectedDate = document.querySelector("input[name=datetime]");
		var checkoutMethodElement = document.querySelector("input[name='attributes[Checkout-Method]']");
		//var shippingDateElement = document.querySelector("input[name='attributes[Shipping-Date]']");
		//var shippingTimeElement = document.querySelector("input[name='attributes[Shipping-Time]']");

		/*if(selectedDate.value!=='undefined'){
		  var setedDate = moment(selectedDate.value).format("YYYY/MM/DD");
		  checkoutMethodElement.value = checkoutMethod;
		  shippingDateElement.value = setedDate;
  
		  updateCartAttributes();
		  addZapietId(setedDate, '', '', checkoutMethod);
		  checkoutBtns.forEach(element => { element.disabled = false });
		}else{
		  checkoutMethodElement.value = '';
		  shippingDateElement.value = '';
  
		  updateCartAttributes();
		  checkoutBtns.forEach(element => { element.disabled = true });
		}*/

		if (checkoutMethod.length > 0) {
			checkoutMethodElement.value = checkoutMethod;
			updateCartAttributes();
			addZapietId('', '', '', checkoutMethod);
			checkoutBtns.forEach(element => { element.disabled = false });
		} else {
			checkoutMethodElement.value = '';

			updateCartAttributes();
			checkoutBtns.forEach(element => { element.disabled = true });
		}
		document.getElementById('proccessSpinner').innerHTML = '';
	}, 1500);
};
const fetchStorePickupDateWiseTimeSlot = async (locationId, selectedDate, storePikupTimeslots) => {
	checkoutBtns.forEach(element => { element.disabled = true });
	document.getElementById('proccessSpinner').innerHTML = '';
	document.getElementById('proccessSpinner').innerHTML = '<div class=spinnerContainer> <i class="fa fa-spinner fa-spin"></i> </div>';
	var storePickupCalendarTimeSlot = document.getElementById('storePickupCalendarTimeSlot');
	var selectedDateToDay = moment(selectedDate).format("dddd").toLowerCase();
	var daysOfWeek = (typeof storePikupTimeslots.daysOfWeek !== 'undefined') ? storePikupTimeslots.daysOfWeek : '';
	var timeInterval = (typeof storePikupTimeslots.interval !== 'undefined') ? storePikupTimeslots.interval : 0;

	storePickupCalendarTimeSlot.innerHTML = '';
	var innerTimeHolderHTML = '';
	if (daysOfWeek !== '') {
		var dayTimeslot = daysOfWeek[selectedDateToDay];
		var _timeArrStartTime = dayTimeslot['min'].hour + ':' + dayTimeslot['min'].minute;
		var _timeArrEndTime = dayTimeslot['max'].hour + ':' + dayTimeslot['max'].minute;
		var times = generateTimeslots(15, _timeArrStartTime, _timeArrEndTime);
		var timeArr = times.filter(function (item) {
			if (selectedDate !== getCurrentDateOnly()) {
				return item;
			} else {
				return (item >= moment().tz("America/New_York").add(15, 'minutes').format('HH:MM')) == true ? item : '';
			}
		});

		if (timeArr.length > 0) {
			innerTimeHolderHTML += '<div class="info-group">';
			innerTimeHolderHTML += '<div class="info-group-left symbol-group">';
			innerTimeHolderHTML += '<div class="info-icon-container">';
			innerTimeHolderHTML += '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 100 100" style="enable-background:new 0 0 100 100;" xml:space="preserve">';
			innerTimeHolderHTML += '<g>';
			innerTimeHolderHTML += '<path d="M90.65,45.87c0,1.56,0,3.13,0,4.69c-0.17,1.34-0.29,2.68-0.51,4.01c-1.39,8.3-4.93,15.56-10.87,21.52   c-9.68,9.7-21.42,13.59-34.97,11.61c-8.38-1.23-15.65-4.96-21.64-10.95C13.66,67.77,9.7,56.85,10.85,44.21   c0.77-8.49,4.1-15.98,9.75-22.37c6.2-7.01,13.92-11.38,23.14-13.02c1.51-0.27,3.03-0.42,4.55-0.62c1.56,0,3.13,0,4.69,0   c0.56,0.06,1.13,0.13,1.69,0.19c8.58,0.96,16.16,4.23,22.59,10c6.87,6.17,11.16,13.82,12.77,22.93   C90.3,42.83,90.45,44.35,90.65,45.87z M50.63,82.48C69.52,82.49,84.84,67.2,84.9,48.26c0.07-18.88-15.32-34.3-34.25-34.31   c-18.89-0.01-34.21,15.28-34.28,34.21C16.31,67.04,31.7,82.46,50.63,82.48z"/>';
			innerTimeHolderHTML += '<path d="M52.4,47.56c0.44,0,0.75,0,1.06,0c5.81,0,11.61,0,17.42,0c1.68,0,2.74,0.75,3.1,2.17c0.43,1.66-0.73,3.32-2.44,3.5   c-0.28,0.03-0.57,0.04-0.86,0.04c-6.88,0-13.75,0-20.63,0.01c-1,0-2-0.09-2.6-0.95c-0.39-0.56-0.74-1.31-0.74-1.98   c-0.05-7.76-0.05-15.52-0.02-23.28c0-1.74,1.25-2.95,2.89-2.93c1.62,0.02,2.8,1.24,2.81,3.01c0.02,6.46,0.01,12.92,0.01,19.38   C52.4,46.83,52.4,47.13,52.4,47.56z"/>';
			innerTimeHolderHTML += '</g>';
			innerTimeHolderHTML += '</svg>';
			innerTimeHolderHTML += '</div>';
			innerTimeHolderHTML += '</div>';
			innerTimeHolderHTML += '<div class="info-group-center label-group">';
			innerTimeHolderHTML += '<div class="info-group-row"></div>';
			innerTimeHolderHTML += '</div>';
			innerTimeHolderHTML += '<div class="info-group-right select-group">';
			innerTimeHolderHTML += '<div class="info-group-row" data-test-id="time-select">';
			innerTimeHolderHTML += '<div id="ember1421" class="pickup-time-select selected ember-view standard-dropdown sg-form-field valid">';
			innerTimeHolderHTML += '<label class="form-field--label" for="ember1421-select">Pickup Time</label>';
			innerTimeHolderHTML += '<div class="select-field-wrap">';
			innerTimeHolderHTML += '<select onChange="setStorePickupTimeSlot();" id="deliveryTimeSlot" class="selected">';
			innerTimeHolderHTML += '<option value="" class="ember-view">Select time slot</option>';
			timeArr.forEach(function (item) {
				innerTimeHolderHTML += '<option data-locationid="' + locationId + '" class="ember-view" value="' + convertFrom24To12Format(item) + '">' + capitalizeFirstLetter(selectedDateToDay) + ', ' + convertFrom24To12Format(item) + '</option>';
			});
			innerTimeHolderHTML += '</select>';
			innerTimeHolderHTML += '</div>';
			innerTimeHolderHTML += '</div>';
			innerTimeHolderHTML += '</div>';
			innerTimeHolderHTML += '</div>';
			innerTimeHolderHTML += '</div>';

			storePickupCalendarTimeSlot.innerHTML = innerTimeHolderHTML;
		} else {
			storePickupCalendarTimeSlot.innerHTML = '<p class="error">Sorry, no time slot available for the selected date.</p>';
		}
	}
	document.getElementById('proccessSpinner').innerHTML = '';
};
const setStorePickupTimeSlot = function setStorePickupTimeSlot(e) {
	document.getElementById('proccessSpinner').innerHTML = '';
	document.getElementById('proccessSpinner').innerHTML = '<div class=spinnerContainer> <i class="fa fa-spinner fa-spin"></i> </div>';
	var e = document.getElementById("deliveryTimeSlot");
	var value = e.options[e.selectedIndex].value;
	var locationId = e.options[e.selectedIndex].getAttribute('data-locationid');
	var selectedDate = document.querySelector("input[name=datetime]");

	var checkoutMethodElement = document.querySelector("input[name='attributes[Checkout-Method]']");
	var pickupLocationIdElement = document.querySelector("input[name='attributes[Pickup-Location-Id]']");
	var pickupDateElement = document.querySelector("input[name='attributes[Pickup-Date]']");
	var pickupTimeElement = document.querySelector("input[name='attributes[Pickup-Time]']");
	var pickupLocationCompanyElement = document.querySelector("input[name='attributes[Pickup-Location-Company]']");
	var pickupLocationAddressLine1Element = document.querySelector("input[name='attributes[Pickup-Location-Address-Line-1]']");
	var pickupLocationAddressLine2Element = document.querySelector("input[name='attributes[Pickup-Location-Address-Line-2]']");
	var pickupLocationCityElement = document.querySelector("input[name='attributes[Pickup-Location-City]']");
	var pickupLocationRegionElement = document.querySelector("input[name='attributes[Pickup-Location-Region]']");
	var pickupLocationPostalCodeElement = document.querySelector("input[name='attributes[Pickup-Location-Postal-Code]']");
	var pickupLocationCountryElement = document.querySelector("input[name='attributes[Pickup-Location-Country]']");

	if (value.length > 0 && typeof locationId !== 'undefined' && selectedDate.value !== 'undefined') {
		var getLocationData = JSON.parse(document.getElementById('location_id_' + locationId).innerText);

		var setedDate = moment(selectedDate.value).format("YYYY/MM/DD");
		var company_name = (getLocationData.company_name !== null) ? getLocationData.company_name : '';
		var address_line_1 = (getLocationData.address_line_1 !== null) ? getLocationData.address_line_1 : '';
		var address_line_2 = (getLocationData.address_line_2 !== null) ? getLocationData.address_line_2 : '';
		var city = (getLocationData.city !== null) ? getLocationData.city : '';
		var region = (getLocationData.region !== null) ? getLocationData.region : '';
		var postal_code = (getLocationData.postal_code !== null) ? getLocationData.postal_code : '';
		var country = (getLocationData.country !== null) ? getLocationData.country : '';

		checkoutMethodElement.value = checkoutMethod;
		pickupLocationIdElement.value = locationId;
		pickupDateElement.value = setedDate;
		pickupTimeElement.value = value;
		pickupLocationCompanyElement.value = company_name;
		pickupLocationAddressLine1Element.value = address_line_1;
		pickupLocationAddressLine2Element.value = address_line_2;
		pickupLocationCityElement.value = city;
		pickupLocationRegionElement.value = region;
		pickupLocationPostalCodeElement.value = postal_code;
		pickupLocationCountryElement.value = country;

		if (document.getElementsByTagName('form')) {
			var formElement = document.getElementsByTagName('form');
			if (formElement.length > 0) {
				for (let i = 0; i < formElement.length; i++) {
					if (formElement[i].action.includes('/cart')) {
						formElement[i].action = "/cart?step=contact_information&method=" + checkoutMethod + "&checkout[shipping_address][company]=" + company_name + "&checkout[shipping_address][address1]=" + address_line_1 + "&checkout[shipping_address][address2]=" + address_line_2 + "&checkout[shipping_address][city]=" + city + "&checkout[shipping_address][country]=" + country + "&checkout[shipping_address][zip]=" + postal_code + "&checkout[shipping_address][province]=" + region + "&discount=+&locale=" + Shopify.locale;
					}
				}
			}
		}

		addZapietId(setedDate, locationId, value, checkoutMethod);
		updateCartAttributes();

		checkoutBtns.forEach(element => { element.disabled = false });
	} else {
		checkoutMethodElement.value = '';
		pickupLocationIdElement.value = '';
		pickupDateElement.value = '';
		pickupTimeElement.value = '';
		pickupLocationCompanyElement.value = '';
		pickupLocationAddressLine1Element.value = '';
		pickupLocationAddressLine2Element.value = '';
		pickupLocationCityElement.value = '';
		pickupLocationRegionElement.value = '';
		pickupLocationPostalCodeElement.value = '';
		pickupLocationCountryElement.value = '';

		if (document.getElementsByTagName('form')) {
			var formElement = document.getElementsByTagName('form');
			if (formElement.length > 0) {
				for (let i = 0; i < formElement.length; i++) {
					if (formElement[i].action.includes('/cart')) {
						formElement[i].action = "/cart";
					}
				}
			}
		}

		updateCartAttributes();
		checkoutBtns.forEach(element => { element.disabled = true });
	}
	document.getElementById('proccessSpinner').innerHTML = '';
};
const changeLocation = function changeLocation() {
	/*document.getElementById('location_text_section').style.display = 'none';
	document.getElementById('location_list').style.display = 'inline-block';*/
	window.location.href = '/pages/order-now';
};
const updateCartAttributes = function updateCartAttributes() {
	var checkoutMethod = document.querySelector("input[name='attributes[Checkout-Method]']");
	var pickupLocationId = document.querySelector("input[name='attributes[Pickup-Location-Id]']");
	var deliveryLocationId = document.querySelector("input[name='attributes[Delivery-Location-Id]']");
	var pickupDate = document.querySelector("input[name='attributes[Pickup-Date]']");
	var pickupTime = document.querySelector("input[name='attributes[Pickup-Time]']");
	var deliveryDate = document.querySelector("input[name='attributes[Delivery-Date]']");
	var deliverySlotId = document.querySelector("input[name='attributes[Delivery-Slot-Id]']");
	var deliveryTime = document.querySelector("input[name='attributes[Delivery-Time]']");
	var shippingDate = document.querySelector("input[name='attributes[Shipping-Date]']");
	var shippingTime = document.querySelector("input[name='attributes[Shipping-Time]']");
	var customAttribute1 = document.querySelector("input[name='attributes[Custom-Attribute-1]']");
	var customAttribute2 = document.querySelector("input[name='attributes[Custom-Attribute-2]']");
	var customAttribute3 = document.querySelector("input[name='attributes[Custom-Attribute-3]']");
	var pickupLocationCompany = document.querySelector("input[name='attributes[Pickup-Location-Company]']");
	var pickupLocationAddress1 = document.querySelector("input[name='attributes[Pickup-Location-Address-Line-1]']");
	var pickupLocationAddress2 = document.querySelector("input[name='attributes[Pickup-Location-Address-Line-2]']");
	var pickupLocationCity = document.querySelector("input[name='attributes[Pickup-Location-City]']");
	var pickupLocationRegion = document.querySelector("input[name='attributes[Pickup-Location-Region]']");
	var pickupLocationPostal = document.querySelector("input[name='attributes[Pickup-Location-Postal-Code]']");
	var pickupLocationCountry = document.querySelector("input[name='attributes[Pickup-Location-Country]']");

	var o = {
		"Checkout-Method": "",
		"Pickup-Location-Id": "",
		"Delivery-Location-Id": "",
		"Pickup-Date": "",
		"Pickup-Time": "",
		"Delivery-Date": "",
		"Delivery-Slot-Id": "",
		"Delivery-Time": "",
		"Shipping-Date": "",
		"Shipping-Time": "",
		"Custom-Attribute-1": "",
		"Custom-Attribute-2": "",
		"Custom-Attribute-3": "",
		"Pickup-Location-Company": "",
		"Pickup-Location-Address-Line-1": "",
		"Pickup-Location-Address-Line-2": "",
		"Pickup-Location-City": "",
		"Pickup-Location-Region": "",
		"Pickup-Location-Postal-Code": "",
		"Pickup-Location-Country": "",
	};

	o["Checkout-Method"] = checkoutMethod.value;
	o["Pickup-Location-Id"] = pickupLocationId.value;
	o["Delivery-Location-Id"] = deliveryLocationId.value;
	o["Pickup-Date"] = pickupDate.value;
	o["Pickup-Time"] = pickupTime.value;
	o["Delivery-Date"] = deliveryDate.value;
	o["Delivery-Slot-Id"] = deliverySlotId.value;
	o["Delivery-Time"] = deliveryTime.value;
	o["Shipping-Date"] = shippingDate.value;
	o["Shipping-Time"] = shippingTime.value;
	o["Custom-Attribute-1"] = customAttribute1.value;
	o["Custom-Attribute-2"] = customAttribute2.value;
	o["Custom-Attribute-3"] = customAttribute3.value;
	o["Pickup-Location-Company"] = pickupLocationCompany.value;
	o["Pickup-Location-Address-Line-1"] = pickupLocationAddress1.value;
	o["Pickup-Location-Address-Line-2"] = pickupLocationAddress2.value;
	o["Pickup-Location-City"] = pickupLocationCity.value;
	o["Pickup-Location-Region"] = pickupLocationRegion.value;
	o["Pickup-Location-Postal-Code"] = pickupLocationPostal.value;
	o["Pickup-Location-Country"] = pickupLocationCountry.value;

	xhrCURLRequest('POST', '/cart/update.js', { attributes: o });
};
let datePickerObject = '';
const initializationDatePicker = function initializationDatePicker(minDate, maxDate, locationId, datesDisabled = [], storePikupTimeslots = []) {
	var tempDisabledDates = [];
	var tempDaysOfWeekDisabled = [];

	if (datesDisabled.length > 0) {
		datesDisabled.forEach(function (entry) {
			if (entry != '') {
				var convertWeek = (entry - 1);
				tempDaysOfWeekDisabled.push(convertWeek);
			}

			if (Array.isArray(entry)) {
				var year = entry[0];
				var month = entry[1] + 1;
				var day = entry[2];
				var date = month + '/' + day + '/' + year;
				tempDisabledDates.push(date);
			}
		});
	};

	const elem = document.querySelector('input[name="datetime"]');
	datePickerObject = new Datepicker(elem, {
		autohide: true,
		showOnClick: true,
		showOnFocus: true,
		datesDisabled: tempDisabledDates,
		daysOfWeekDisabled: tempDaysOfWeekDisabled,
		maxView: 0,
		language: 'en',
		minDate: minDate,
		maxDate: maxDate
	});

	elem.addEventListener('changeDate', function (e, details) {
		var selectedDate = moment(e.detail.date).format("YYYY-MM-DD");
		if (deliveryTypeHandle == 'nation') {
			setShippingDate();
		} else if (deliveryTypeHandle == 'delivery' || deliveryTypeHandle == 'market' || deliveryTypeHandle == 'local') {
			if (sessionStorage.getItem('delivery_type') !== 'SUPERMARKET DELIVERY') {
				fetchLocationDateWiseTimeSlot(locationId, selectedDate);
			} else {
				var checkoutMethodElement = document.querySelector("input[name='attributes[Checkout-Method]']");
				var deliveryLocationIdElement = document.querySelector("input[name='attributes[Delivery-Location-Id]']");
				var deliveryDateElement = document.querySelector("input[name='attributes[Delivery-Date]']");

				var localDeliveryZipCode = sessionStorage.getItem('location_zip') || "";
				if (localDeliveryZipCode != '') {
					if (document.getElementsByTagName('form')) {
						var formElement = document.getElementsByTagName('form');
						if (formElement.length > 0) {
							for (let i = 0; i < formElement.length; i++) {
								if (formElement[i].action.includes('/cart')) {
									formElement[i].action = "/cart?step=contact_information&method=" + checkoutMethod + "&skip_shopify_pay=true&shipping_address_zip=" + localDeliveryZipCode + "&discount=+&locale=" + Shopify.locale;
								}
							}
						}
					}
				}

				checkoutMethodElement.value = checkoutMethod;
				deliveryLocationIdElement.value = locationId;
				deliveryDateElement.value = selectedDate;

				updateCartAttributes();
				addZapietId(selectedDate, locationId, '', checkoutMethod);

				checkoutBtns.forEach(element => { element.disabled = false });
			}
		} else if (deliveryTypeHandle == 'standard-pickup' || deliveryTypeHandle == "market-pickup") {
			fetchStorePickupDateWiseTimeSlot(locationId, selectedDate, storePikupTimeslots);
		}
	});
};
const InitIconClickEvent = function InitIconClickEvent() {
	const elem = document.querySelector('input[name="datetime"]');
	let datePickerElement = document.querySelector('.datepicker.datepicker-dropdown');
	if (datePickerElement?.classList?.contains('datepicker-active')) {
		datePickerElement?.classList?.remove('datepicker-active');
	} else {
		datePickerElement?.classList?.add('datepicker-active');
		elem.focus();
	};
};
const addZapietId = async function addZapietId(setedDate, locationId, time, checkoutMethod) {
	let cartResponse = await xhrCURLRequest('GET', 'cart.js');
	if (cartResponse.status == 200) {
		var result = JSON.parse(cartResponse.response);
		var items = result.items;

		const ZapietId = getZapietId({
			date: setedDate,
			start_time: time,
			time: time,
			location_id: locationId,
			method: checkoutMethod
		});

		var properties = {
			'_ZapietId': ""
		}

		var exists = items.filter(function (el) { return el.properties.hasOwnProperty('_ZapietId'); });
		if (exists.length > 0) {
			var key = exists[0].key;
			var quantity = exists[0].quantity;
			if (Object.keys(exists[0].properties).length > 0) {
				var propertiesArray = Object.entries(exists[0].properties);
				if (propertiesArray.length > 0) {
					propertiesArray.forEach(function (item) {
						var key = item[0];
						var value = item[1];
						properties[key] = value;
					});
				}
			}
			properties['_ZapietId'] = ZapietId;
			xhrCURLRequest('POST', '/cart/change.js', { properties: properties, id: key, quantity: quantity });
		} else {
			var key = items[0].key;
			var quantity = items[0].quantity;
			if (Object.keys(items[0].properties).length > 0) {
				var propertiesArray = Object.entries(items[0].properties);
				if (propertiesArray.length > 0) {
					propertiesArray.forEach(function (item) {
						var key = item[0];
						var value = item[1];
						properties[key] = value;
					});
				}
			}
			properties['_ZapietId'] = ZapietId;
			xhrCURLRequest('POST', '/cart/change.js', { properties: properties, id: key, quantity: quantity });
		}
	}
};

function capitalizeFirstLetter(string) {
	return string.charAt(0).toUpperCase() + string.slice(1);
}
function getZapietId(params) {
	var fomatted_date = '';
	if (params.date && !params.time) {
		var fomatted_date = params.date.replace(/\//g, "-");
		fomatted_date = fomatted_date + 'T00:00:00Z';
	} else if (params.date && params.start_time) {
		var fomatted_date = params.date.replace(/\//g, "-");
		fomatted_date = fomatted_date + 'T' + params.start_time + ':00Z';
	}
	return this.encodeZapietId({
		M: this.getMethodKey(params.method),
		L: (params.location_id) ? params.location_id : "",
		D: fomatted_date,
		P: ""
	});
};
function getMethodKey(method) {
	if (method == 'delivery') {
		return 'D';
	} else if (method == 'pickup') {
		return 'P';
	} else {
		return 'S';
	}
};
function encodeZapietId(params) {
	const ret = [];
	for (let d in params) {
		if (params[d]) {
			ret.push(d + '=' + params[d]);
		}
	}
	return ret.join('&');
}
const getCurrentTimein24 = () => {
	var today = new Date();
	var dt = new Date(today);
	var time = dt.getHours() + ":" + (dt.getMinutes());
	return time;
};
const getNewCurrentTimein24 = () => {
	var today = new Date();
	var dt = new Date(today);
	var hs = dt.getHours();
	var ms = dt.getMinutes();

	if (dt.getMinutes() >= 50) {
		if (dt.getHours() < 24) {
			hs = dt.getHours() + 1;
		}
		ms = 60;
	} else {
		ms = dt.getMinutes() + 10;
	}

	var time = hs + ":" + ms;
	return time;
};
const getNextDayDate = (separator = "-") => {
	var today = new Date();
	var tomorrow = new Date(today.getTime() + (24 * 60 * 60 * 1000));

	var day = String(tomorrow.getDate()).padStart(2, '0');
	var month = String(tomorrow.getMonth() + 1).padStart(2, '0'); //January is 0!
	var year = tomorrow.getFullYear();

	return `${year}${separator}${month}${separator}${day}`;
};